import React from "react";
import Icon1 from "../assets/images/paticon1.png";
import Icon2 from "../assets/images/paticon2.png";
import Icon3 from "../assets/images/paticon3.png";
import Icon4 from "../assets/images/paticon4.png";

function Patients() {
  return (
    <div className="patients py-20 sm:py-10 text-white">

      {/* Heading */}
      <div className="text-center relative z-2 px-4">
        <h1 className="headingFont sm:text-[40px] md:text-[55px] lg:text-[40px] x:text-[50px] xl:text-[50px] 2xl:text-[60px]">
          For Patients
        </h1>

        <p className="w-[95%] sm:w-[90%] md:w-[80%] lg:w-[70%] headingFont mx-auto md:text-[20px] lg:text-[15px] x:text-[17px] xl:text-[17px] 2xl:text-[21px] leading-8">
          Our platform ensures secure, private consultations and easy access to
          your medical records. Experience the ease and convenience of virtual
          healthcare, tailored to fit your busy lifestyle.
        </p>
      </div>

      {/* Content */}
      <div
        className="
        relative z-2 flex flex-wrap 
        sm:flex-col md:flex-col 
        l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 
        w-[92%] sm:w-[95%] md:w-[90%] lg:w-[80%] 
        mx-auto mt-12 sm:mt-16 lg:mt-20
      "
      >

        {/* CARD 1 */}
        <div
          className="
          flex 
          sm:flex-col md:flex-col
          l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 

          items-center sm:text-center md:text-center

          l:w-[50%] x:w-[50%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] 
          sm:w-[100%] md:w-[100%] w-[50%] 

          gap-x-7

          sm:backdrop-blur-md
          sm:bg-white/10
          sm:border sm:border-white/20
          sm:rounded-[28px]
          sm:px-5 sm:py-8

          md:backdrop-blur-md
          md:bg-white/10
          md:border md:border-white/20
          md:rounded-[28px]
          md:px-6 md:py-8

          sm:mb-7 md:mb-7
        "
        >
          <img
            className="
            2xl:w-[150px] 2xl:h-[150px]
            x:w-[100px] x:h-[100px]
            xl:w-[100px] xl:h-[100px]
            lg:w-[80px] lg:h-[80px]

            sm:h-[80px] sm:w-[80px]
            md:h-[90px] md:w-[90px]

            sm:bg-white sm:p-4 sm:rounded-full
            md:bg-white md:p-4 md:rounded-full
            "
            src={Icon1}
            alt=""
          />

          <div>
            <h1
              className="
              headingFont

              2xl:text-[25px]
              x:text-[22px]
              xl:text-[22px]

              sm:text-center md:text-center
              sm:mt-5 md:mt-5

              sm:text-[22px]
              md:text-[26px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
            "
            >
              Tele Medicine
            </h1>

            <p
              className="
              mt-3 headingFont

              w-[80%]
              sm:w-full
              md:w-full

              sm:text-[15px]
              md:text-[17px]

              2xl:text-[20px]
              xl:text-[16px]
              x:text-[16px]
              lg:text-[14px]

              sm:text-center md:text-center
              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left

              sm:leading-8
              md:leading-8
              xl:leading-7
              2xl:leading-8

              text-white

              sm:mx-auto md:mx-auto
            "
            >
              Telemedicine leverages technology to connect patients with
              healthcare providers for consultations, diagnosis, and treatment,
              regardless of geographic barriers. High-definition video calls for
              face-to-face interaction with healthcare professionals.
            </p>
          </div>
        </div>

        {/* CARD 2 */}
        <div
          className="
          flex 
          sm:flex-col md:flex-col
          l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 

          items-center sm:text-center md:text-center

          l:w-[50%] x:w-[50%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] 
          sm:w-[100%] md:w-[100%] w-[50%] 

          gap-x-7

          sm:backdrop-blur-md
          sm:bg-white/10
          sm:border sm:border-white/20
          sm:rounded-[28px]
          sm:px-5 sm:py-8

          md:backdrop-blur-md
          md:bg-white/10
          md:border md:border-white/20
          md:rounded-[28px]
          md:px-6 md:py-8

          sm:mb-7 md:mb-7
        "
        >
          <img
            className="
            2xl:w-[150px] 2xl:h-[150px]
            x:w-[100px] x:h-[100px]
            xl:w-[100px] xl:h-[100px]
            lg:w-[80px] lg:h-[80px]

            sm:h-[80px] sm:w-[80px]
            md:h-[90px] md:w-[90px]

            sm:bg-white sm:p-4 sm:rounded-full
            md:bg-white md:p-4 md:rounded-full
            "
            src={Icon2}
            alt=""
          />

          <div>
            <h1
              className="
              headingFont

              2xl:text-[25px]
              x:text-[22px]
              xl:text-[22px]

              sm:text-center md:text-center
              sm:mt-5 md:mt-5

              sm:text-[22px]
              md:text-[26px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
            "
            >
              Electronic Health Records (EHR)
            </h1>

            <p
              className="
              mt-3 headingFont

              w-[80%]
              sm:w-full
              md:w-full

              sm:text-[15px]
              md:text-[17px]

              2xl:text-[20px]
              xl:text-[16px]
              x:text-[16px]
              lg:text-[14px]

              sm:text-center md:text-center
              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left

              sm:leading-8
              md:leading-8
              xl:leading-7
              2xl:leading-8

              text-white

              sm:mx-auto md:mx-auto
            "
            >
              A comprehensive digital record system for storing and managing
              patient health information. All patient information in one place,
              including medical history, lab results, and treatment plans.
            </p>
          </div>
        </div>

        {/* CARD 3 */}
        <div
          className="
          flex 
          sm:flex-col md:flex-col
          l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 

          items-center sm:text-center md:text-center

          l:w-[50%] x:w-[50%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] 
          sm:w-[100%] md:w-[100%] w-[50%] 

          gap-x-7

          sm:backdrop-blur-md
          sm:bg-white/10
          sm:border sm:border-white/20
          sm:rounded-[28px]
          sm:px-5 sm:py-8

          md:backdrop-blur-md
          md:bg-white/10
          md:border md:border-white/20
          md:rounded-[28px]
          md:px-6 md:py-8

          sm:mb-7 md:mb-7
        "
        >
          <img
            className="
            2xl:w-[150px] 2xl:h-[150px]
            x:w-[100px] x:h-[100px]
            xl:w-[100px] xl:h-[100px]
            lg:w-[80px] lg:h-[80px]

            sm:h-[80px] sm:w-[80px]
            md:h-[90px] md:w-[90px]

            sm:bg-white sm:p-4 sm:rounded-full
            md:bg-white md:p-4 md:rounded-full
            "
            src={Icon3}
            alt=""
          />

          <div>
            <h1
              className="
              headingFont

              2xl:text-[25px]
              x:text-[22px]
              xl:text-[22px]

              sm:text-center md:text-center
              sm:mt-5 md:mt-5

              sm:text-[22px]
              md:text-[26px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
            "
            >
              Scheduling Appointment
            </h1>

            <p
              className="
              mt-3 headingFont

              w-[80%]
              sm:w-full
              md:w-full

              sm:text-[15px]
              md:text-[17px]

              2xl:text-[20px]
              xl:text-[16px]
              x:text-[16px]
              lg:text-[14px]

              sm:text-center md:text-center
              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left

              sm:leading-8
              md:leading-8
              xl:leading-7
              2xl:leading-8

              text-white

              sm:mx-auto md:mx-auto
            "
            >
              A user-friendly platform for patients to schedule, reschedule, or
              cancel appointments with their healthcare providers.
            </p>
          </div>
        </div>

        {/* CARD 4 */}
        <div
          className="
          flex 
          sm:flex-col md:flex-col
          l:flex-row x:flex-row lg:flex-row xl:flex-row 2xl:flex-row 

          items-center sm:text-center md:text-center

          l:w-[50%] x:w-[50%] lg:w-[50%] xl:w-[50%] 2xl:w-[50%] 
          sm:w-[100%] md:w-[100%] w-[50%] 

          gap-x-7

          sm:backdrop-blur-md
          sm:bg-white/10
          sm:border sm:border-white/20
          sm:rounded-[28px]
          sm:px-5 sm:py-8

          md:backdrop-blur-md
          md:bg-white/10
          md:border md:border-white/20
          md:rounded-[28px]
          md:px-6 md:py-8

          sm:mb-7 md:mb-7
        "
        >
          <img
            className="
            2xl:w-[150px] 2xl:h-[150px]
            x:w-[100px] x:h-[100px]
            xl:w-[100px] xl:h-[100px]
            lg:w-[80px] lg:h-[80px]

            sm:h-[80px] sm:w-[80px]
            md:h-[90px] md:w-[90px]

            sm:bg-white sm:p-4 sm:rounded-full
            md:bg-white md:p-4 md:rounded-full
            "
            src={Icon4}
            alt=""
          />

          <div>
            <h1
              className="
              headingFont

              2xl:text-[25px]
              x:text-[22px]
              xl:text-[22px]

              sm:text-center md:text-center
              sm:mt-5 md:mt-5

              sm:text-[22px]
              md:text-[26px]

              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left
            "
            >
              e-Prescription
            </h1>

            <p
              className="
              mt-3 headingFont

              w-[80%]
              sm:w-full
              md:w-full

              sm:text-[15px]
              md:text-[17px]

              2xl:text-[20px]
              xl:text-[16px]
              x:text-[16px]
              lg:text-[14px]

              sm:text-center md:text-center
              l:text-left x:text-left lg:text-left xl:text-left 2xl:text-left

              sm:leading-8
              md:leading-8
              xl:leading-7
              2xl:leading-8

              text-white

              sm:mx-auto md:mx-auto
            "
            >
              e-Prescription streamlines the prescription process by allowing
              healthcare providers to send prescriptions directly to pharmacies
              electronically.
            </p>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Patients;